	
import { CopyrightYear, PageDefinition } from "../../../Infrastructure/PageDefinition";
import { SettingService, Watch,SettingFilter, PrepareTranslate, Component, UserService, BaseTLDetailComponent, VersionService, AxiosResponse, tlLogDebug, tlLogError } from "../../../Infrastructure/CorBase/CoreBase";
	@Component
	export default class RegistrationSelfBase extends BaseTLDetailComponent {
		protected versionNumberInLoginPage: string = "";

		CopyrightYear = CopyrightYear;
		versionService: VersionService = new VersionService();
		userService: UserService = new UserService();
		settingService: SettingService = new SettingService();

		isCorrectEmailValSearch = true;
		isCorrectEmailVal = true;
		vPasswordNew: boolean = true;
		vPasswordNew2: boolean = true;

		//showEmail = true;

		formData = {
			firstname: '',
			surname: '',
			tenantName: '',	
			passwordNew: '',
			passwordNew2: '',
			email: ''
		};	

		//@ts-ignore
		@Watch('$i18n.locale')
		changeLanguageBase(value: boolean, oldValue: boolean) {
			if (this.$i18n.locale == '') {
				this.recongnizeLang();
			}
		}



		notAllowEmails = "";
		labelWidth = "0";
		inputWidth = "13";
		
		
		versionNumber: string = '';
		isActualVersion = false;
		languageSet = '';
		
		isTestEnvironment = false;

		prepareTranslate= new PrepareTranslate();


		createdBase() {
			this.isAllowRegisteredSelf();
		}

		isAllowRegisteredSelf() {
			let settingFilter: SettingFilter = new SettingFilter(null, true, false, false, null, null, 'SET_SelfRegistration_Enabled');
			this.settingService.getGlobalFilter(settingFilter).then((response) => {
				let allow = response.data as boolean;

				if (allow==false) {
					this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('registrationSelf.errorNotAllowRegistrationSelf').toString());
				}

			});
		}

		disabledRegistration() {
			var result = (!this.isCorrectEmailVal || this.formData.email == '') || !this.allowChangePasswordBase();
			return result;
		}

		goToLogin = true;
		goBackModal() {
			if (this.goToLogin) {
				this.goBack();
			}
			else {
				this.goToLogin = true;
			}
		}

		registrationBase() {
			this.isBusy = true;
			this.isCorrectEmailValSearch = false;
			this.userService.registrationSelf(this.formData).then(res => {
				this.isBusy = false;

				if (res.data.errorMessage != '') {
					this.goToLogin = false;
					this.notAllowEmails = this.formData.email;
					this.showAlertModalWithTitleAndContent(this.$t('global.titleError').toString(), res.data.errorMessage);
				}
				else {
					this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('registrationSelf.registrationSuccess').toString());
				}
			}).catch(error => {
				this.isCorrectEmailValSearch = true;
				this.isBusy = false;
				this.showAlertModalWithTitleAndContent(this.$t('global.titleError').toString(), error.data.errors[0]);
			});
		}

		goBack() {
			this.$router.push({ name: "Login" });
		}





		disabledSetPassword() {
			var result = !this.vPasswordNew || !this.vPasswordNew2 ;
			return result;
		}

	

		allowChangePasswordBase() {
			return this.vPasswordNew && this.vPasswordNew2;
		}

		isCorrectEmailBase(item: any) {
			this.isCorrectEmailVal = item;
		}

		isCorrectPassNewBse(value: any) {
			this.vPasswordNew = value;
		}
		isCorrectPassNewBase2(value: any) {
			this.vPasswordNew2 = value;
		}

	
		getVersionNumberFromREST() {
			this.versionService.getAll().then((response) => {
				let versionNumber = response.data.version as string;
				this.isTestEnvironment = response.data.isTestingEnviroment;
				if (versionNumber && versionNumber.length > 0) {
					this.checkVersionNumber(response.data.version);
				}
			}).catch((error) => {
				this.checkVersionNumber('no version info');
			});
		}

		checkVersionNumber(versionNumberFromRest: string) {
			let versionNumberInStore = this.$store.state.versionNumber;
			let versionNumberInREST = versionNumberFromRest;
			if (versionNumberInStore != versionNumberInREST) {
				this.$store.commit('setVersionNumber', { versionNumber: versionNumberInREST });
				// VaP - dodelana kontrola, aby se obnoveni stranky nedelalo pri kazdem prvnim zobrazeni loginpage, ale jenom kdyz bude verze aplikace v prohlizeci jina nez je na serveru
				//     - puvodni logiku (versionNumberInStore != versionNumberInREST) ponecham, aby nedoslo k nekonecnemu refreshnuti stranky, p okud nekdo zapomene zmenit cislo verze v login.vue nebo ve VersionController.cs a cisla verzi byla jina
				if (this.versionNumberInLoginPage != versionNumberInREST) {
					window.location.reload();
				}
			} else {
				this.isActualVersion = true;
			}
			this.versionNumber = versionNumberInREST;
		}

		protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return super.NoCall()
		}

		protected refreshItems(items: any, refreshData: any): any {
			return items;
		}	

		controlValidCode(code: string) {
			return false;
		}

		enterPressBase(): void {
			//this.showEmail ? this.sendEmail() : this.changePasswordBase();
		}

		protected recongnizeLang(): void {
			var lang = navigator.language;
			lang = lang.substr(0, 2).toUpperCase();		
			if (this.$i18n.availableLocales.indexOf(lang) != -1) {
				this.$i18n.locale = lang;
			}
			else {
				this.$i18n.locale = 'EN';
			}
			this.$store.commit('setLanguage', lang);
		}

		protected setLanguage(lang: string): void {
			this.$i18n.locale = lang;
			this.$store.commit('setLanguage', lang);
			this.languageSet = lang;
		}

		
	}

